import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import { ColumnsType } from "antd/es/table";
import { all_routes } from "../router/all_routes";
import useApi from "../../core/customhook/useApi";
import BreadCrumbForm from "../all-forms/common-components/BreadCrumbForm";
// import CommonSelect2 from "../../core/common/commonSelect2";
import Loading from "../../core/common/custom-loading/Loading";
import { get_enabled_probation_list, get_new_joiners } from "../../environment";
import { formatDateDDMMMMYYYY, formattedDate } from "../../core/common/formattedDate";

export interface DataProps {
  emp_id: number;
  employee_id: string;
  full_name: string;
  department: string;
  email_id: string;
  assessment_id: number;
  enabled_on: string;
  submitted_on: string;
  final_decision: string;
  is_enable: number;
  is_form_filled: number;
}

interface PaginationProps {
  current: number;
  pageSize: number;
  total: number;
}

// ('Pending', 'Selected', 'Rejected', 'Extension')
const statusStyle: Record<string, string> = {
  pending: "",
  selected: "badge-success badge-xs text-white",
  rejected: "badge-danger badge-xs text-white",
  extension: "badge-warning badge-xs text-white",
};

const ReviewData: any = {
  a: "Extension",
  b: "Terminated",
  c: "Confirmed",
};

const EnabledProbationList = () => {
  const navigate = useNavigate();
  const [allItemList, setAllItemList] = useState<DataProps[]>([]);
  const [pagination, setPagination] = useState<PaginationProps>({
    current: 1,
    pageSize: 10, // limit of records
    total: 1,
  });

  //   -- api
  const { callApi, loading, error } = useApi("", {
    method: "GET",
    autoCall: false,
  });

  const columns: ColumnsType<DataProps> = useMemo(
    () => [
      {
        title: "Sr No.",
        dataIndex: "SrNo",
        render: (text: string, record: any, index: any) => (
          <h6 className="fw-medium fs-14 text-dark text-center">{index + 1}</h6>
        ),
        sorter: false,
      },
      {
        title: "Employee ID",
        dataIndex: "employee_id",
        render: (text: string, record: any, index: any) => (
          <p className="text-capitalize" style={{ width: 100 }}>
            {text ?? "-"}
          </p>
        ),
        sorter: (a: DataProps, b: DataProps) =>
          (a.employee_id ?? "").localeCompare(b.employee_id ?? ""),
      },
      {
        title: "Employee Name",
        dataIndex: "full_name",
        render: (text: string, record: any, index: any) => (
          <p className="text-capitalize" style={{ width: 140 }}>
            {text ?? "-"}
          </p>
        ),
        sorter: (a: DataProps, b: DataProps) =>
          (a.full_name ?? "").localeCompare(b.full_name ?? ""),
      },
      {
        title: "Email",
        dataIndex: "email_id",
        render: (text: string, record: any, index: any) => (
          <p className="text-capitali" style={{ width: 140 }}>
            {text ?? "-"}
          </p>
        ),
        sorter: (a: DataProps, b: DataProps) =>
          (a.email_id ?? "").localeCompare(b.email_id ?? ""),
      },
      {
        title: "Department",
        dataIndex: "department",
        render: (text: string, record: any, index: any) => (
          <p className="text-capitalize" style={{ width: 120 }}>
            {text ?? "-"}
          </p>
        ),
        sorter: (a: DataProps, b: DataProps) =>
          (a.department ?? "").localeCompare(b.department ?? ""),
      },
      {
        title: "Fill Form",
        dataIndex: "",
        render: (text: string, record: any) => {
          return (
            <div
              className="d-flex justify-content-center"
              style={{ width: "80px" }}
            >
              <button
                type="button"
                disabled={record?.is_form_filled}
                className="btn btn-secondary btn-sm textlight d-flex align-items-center py-1"
                onClick={() => {
                  navigate(
                    `${all_routes.probationAssessmentForm}/${record?.emp_id}/${record?.assessment_id}`,
                  );
                }}
              >
                Fill Form
              </button>
            </div>
          );
        },
      },
      {
        title: "Started on",
        dataIndex: "enabled_on",
        render: (text: string, record: any) => {
          const date = formatDateDDMMMMYYYY(formattedDate(text?.split("T")[0]));
          return <div style={{ width: 140 }}>{date ?? "-"}</div>;
        },
        sorter: (a: DataProps, b: DataProps) => {
          const dateA = a.enabled_on ? new Date(a.enabled_on).getTime() : 0;
          const dateB = b.enabled_on ? new Date(b.enabled_on).getTime() : 0;
          return dateA - dateB;
        },
      },
      {
        title: "Form Status",
        dataIndex: "is_form_filled",
        render: (text: string, record: any, index: any) => (
          <p className="text-capitalize" style={{ width: 140 }}>
            {record?.is_form_filled ? "Filled" : "Pending"}
          </p>
        ),
        sorter: (a: DataProps, b: DataProps) =>
          (a.is_form_filled ?? 0) - (b.is_form_filled ?? 0),
      },
      {
        title: "Assessment Review",
        dataIndex: "final_decision",
        render: (text: string, record: any, index: any) => {
          const review = text
            ? ReviewData[text?.toLocaleLowerCase() ?? ""]
            : null;
          return (
            <span
              className={`badg text-black-50 ${statusStyle[text?.toLowerCase()]} d-inline-flex align-items-center `}
            >
              {review ?? "-"}
            </span>
          );
        },
        sorter: (a: DataProps, b: DataProps) =>
          (a.final_decision ?? "").localeCompare(b.final_decision ?? ""),
      },
      {
        title: "Submitted on",
        dataIndex: "submitted_on",
        render: (text: string, record: any) => {
          const value = record?.is_form_filled
            ? formatDateDDMMMMYYYY(formattedDate(text?.split("T")[0]))
            : "-";
          return <div style={{ width: 140 }}>{value}</div>;
        },
        sorter: (a: DataProps, b: DataProps) => {
          const dateA = a.submitted_on ? new Date(a.submitted_on).getTime() : 0;
          const dateB = b.submitted_on ? new Date(b.submitted_on).getTime() : 0;
          return dateA - dateB;
        },
      },
      {
        title: "Action",
        render: (text: string, record: any) => {
          return (
            <div
              className="d-flex justify-content-center"
              style={{ width: "80px" }}
            >
              <button
                type="button"
                className="btn btn-secondary btn-sm textlight d-flex align-items-center py-1"
                disabled={!!!record?.is_form_filled}
                onClick={() => {
                  navigate(
                    `${all_routes.probationAssessmentFormByID}/${record?.emp_id}`,
                  );
                }}
              >
                <i className="ti ti-eye pe-1"></i>
                View
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  const fetchData = useCallback(async () => {
    try {
      const { current, pageSize } = pagination;
      const resp = await callApi(
        undefined,
        `${get_enabled_probation_list}`,
        // `${get_new_joiners}?page=${current}&limit=${pageSize}`,
      );
      // console.log("response:", resp.data);
      if (resp?.success) {
        const final = resp?.data;
        const pageData = resp?.pagination;
        setAllItemList(final?.length > 0 && final);
        setPagination({
          current: pageData?.currentPage,
          pageSize: pageData?.limit,
          total: pageData?.total,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [pagination.current, pagination.pageSize]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <BreadCrumbForm
            title="Employee Probation Forms"
            linkTitle="Employee Probation Forms"
            prevMenu={false}
          />
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Probation Assessment List</h5>
            </div>
            <div className="card-body p-0">
              {loading ? (
                <Loading />
              ) : (
                <Table
                  dataSource={allItemList}
                  columns={columns}
                  Selection={false}
                  totalEmployees={pagination.total}
                  currentPage={pagination.current}
                  setCurrentPage={(page) =>
                    setPagination((prev) => ({ ...prev, current: page }))
                  }
                  limit={pagination.pageSize}
                  setLimit={(limit) =>
                    setPagination((prev) => ({ ...prev, pageSize: limit }))
                  }
                />
              )}
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default EnabledProbationList;
